import firebase from 'firebase';
//eslint-disable-next-line
import firestore from 'firebase/firestore';

const config = {
    apiKey: 'AIzaSyBYwOo65EJXZDX8I82YshKhwrF3b4mxcPk',
    authDomain: 'enele-e47f5.firebaseapp.com',
    databaseURL: 'https://enele-e47f5.firebaseio.com',
    projectId: 'enele-e47f5',
    storageBucket: 'enele-e47f5.appspot.com',
    messagingSenderId: '203422452900'
}

firebase.initializeApp(config)

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage();

export const getApiKey = () => (config.apiKey)

export const keygen = () => {
    let keygenRef = firebase.firestore().collection('keygen').doc();
    return keygenRef.id;
}



// WEBPACK FOOTER //
// ./src/services/firebase/index.js